<template>
  <div>
    <div>
      <b>Fees Burnt</b>

      <span id="fees_stats">ⓘ</span>
      <StatsPopover target="fees_stats"
                    :stats="stats"
                    :data="data"
                    @toggle="toggle_stat($event)"/>
    </div>

    <apexchart id="report_metric_fees"
               type=line
               v-bind:options="fees_options"
               :series="series" />
  </div>
</template>

<script>
import util   from '../../../util';
import config from '../../../config';

import StatsPopover from './StatsPopover'
const StatsCalculator = require('./stats_calculator').default

export default {
  name: 'MetricsFeesBurnt',

  mixins : [StatsCalculator],

  components : {StatsPopover},

  props : {
    subreport : {
      type : Boolean,
      defalt : false
    }
  },

  data : function(){
    return {
       stats : ['average']
    };
  },

  computed : {
    period : function(){
      return this.subreport ? this.$store.state.report.selected.subperiod :
                              this.$store.state.report.period;
    },

    data : function(){
      return this.subreport ? this.$store.state.report.subreport["fees"] :
                              this.$store.state.report.data["fees"];
    },

    values : function(){
      return Object.values(this.data).map(function(d){
               return d / config.DROPS_PER_XRP;
             })
    },

    series : function(){
      var series = [{
        name : "fees",
        data: this.values
      }];

      if(this.stat_enabled('average'))
        series.push(this.average_series);

      if(this.stat_enabled('median'))
        series.push(this.median_series);

      return series;
    },

    fees_options : function(){
      return {
        chart: {
           animations: {
                enabled: true,
                easing: 'easeinout',
                speed: 100,
                animateGradually: {
                    enabled: true,
                    delay: 100
                },
                dynamicAnimation: {
                    enabled: true,
                    speed: 150
                }
            }
        },
        xaxis : {
          type: 'datetime',
          categories : Object.keys(this.data)
        },

        tooltip : {
          x : { show : false, format : this.period == '86400' ? 'yyyy-MM-dd' : "yyyy-MM-dd HH:mm" }
        },

        yaxis : {
          labels : {
            formatter : function(v){
              return util.delim_value(util.round_value(v, 3));
            }
          },

          min : 0
        }
      };
    }
  }
}
</script>

<style scoped>
#fees_stats{
  margin-left: 5px;
  cursor: pointer;
}
</style>
